var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg008(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1186.431,
    height: 1186.431,
    viewBox: "0 0 1186.431 1186.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16775",
    "data-name": "Grupo 16775",
    transform: "translate(-1147.257 -728.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Close-Square",
    "data-name": "Iconly/Bulk/Close-Square",
    transform: "translate(1147.257 728.472)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M335.76,1186.431H850.078c201.1,0,336.353-141.185,336.353-351.184V350.59C1186.431,141.185,1051.178,0,850.078,0H335.76C134.66,0,0,141.185,0,350.59V835.247c0,210,134.66,351.184,335.76,351.184",
    fill: "#f02f65",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16776",
    "data-name": "Grupo 16776",
    transform: "translate(1353.729 982.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(48.162 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(170.509 186.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15206",
    "data-name": "Trazado 15206",
    d: "M70.158,0A70.158,70.158,0,1,1,0,70.158,70.158,70.158,0,0,1,70.158,0Z",
    transform: "translate(0)",
    fill: "#f02e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15205",
    "data-name": "Trazado 15205",
    d: "M70.158,0A70.158,70.158,0,1,1,0,70.158,70.158,70.158,0,0,1,70.158,0Z",
    transform: "translate(196.663)",
    fill: "#f02e65"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15199",
    "data-name": "Trazado 15199",
    d: "M339,75.1c-145.5,0-263.869,118.32-263.869,263.755S193.5,602.607,339,602.607s263.869-118.32,263.869-263.755S484.5,75.1,339,75.1M339,0C526.222,0,678,151.709,678,338.852S526.222,677.7,339,677.7,0,525.994,0,338.852,151.775,0,339,0Z",
    transform: "translate(0 0)",
    fill: "#f02e65"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15195",
    "data-name": "Trazado 15195",
    d: "M24.417,0H56.893A24.417,24.417,0,0,1,81.31,24.417V169.476a24.417,24.417,0,0,1-24.417,24.417H24.417A24.417,24.417,0,0,1,0,169.476V24.417A24.417,24.417,0,0,1,24.417,0Z",
    transform: "translate(0 238.973)",
    fill: "#f02e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15196",
    "data-name": "Trazado 15196",
    d: "M24.417,0H56.893A24.417,24.417,0,0,1,81.31,24.417V169.476a24.417,24.417,0,0,1-24.417,24.417H24.417A24.417,24.417,0,0,1,0,169.476V24.417A24.417,24.417,0,0,1,24.417,0Z",
    transform: "translate(692.176 238.973)",
    fill: "#f02e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M-6834,16405.133l-6.45-37.021c152.153-26.525,268.941-121.393,270.1-122.334l23.855,29.012C-6551.546,16278.941-6672.186,16376.918-6834,16405.133Z",
    transform: "translate(7252.338 -15924.392)",
    fill: "#f02e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M33.358,0h27.1a33.358,33.358,0,1,1,0,66.716h-27.1A33.358,33.358,0,1,1,33.358,0Z",
    transform: "translate(354.088 428.649)",
    fill: "#f02e65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg008);
export default __webpack_public_path__ + "static/media/008.9e30581fd206176e1222b6fd4f693b89.svg";
export { ForwardRef as ReactComponent };